import { Component, Inject } from '@angular/core';
import { ISitemap, SITEMAP } from 'pbc.angular';
import { IFilterConfig, ISelection } from 'pbc.types';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { FelderQueryFilterConfig, IFelderQueryShapes, IFelderResponse } from 'fa-kt.types';
import { FelderService } from '../service';

@Component({
  selector: 'fa-kt-felder-filter',
  templateUrl: './felder-filter.component.html',
  styleUrls: ['./felder-filter.component.css'],
})
export class FelderFilterComponent {
  readonly subscriptions: Subscription[] = [];

  public FelderFilterConfig: IFilterConfig<IFelderResponse>;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public felder: FelderService,
  ) {
    this.FelderFilterConfig = FelderQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.felder.shapes$.subscribe((shapes: IFelderQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.FelderFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.FelderFilterConfig[index].selections = shapes;
  }
}
